import { Id } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export const customValueKeys = {
  all: () => ["admin", "customValues"],
  list: (customTypeId: Id, params?: QueryParams) => [
    ...customValueKeys.all(),
    customTypeId,
    ...(params ? [params] : [])
  ],
  single: (customTypeId: Id, customValueId: Id) => [...customValueKeys.all(), customTypeId, customValueId],
  unused: (customTypeId: Id) => [...customValueKeys.all(), customTypeId, "unused"]
};
